<div
  class="progress__indicator__container progress__indicator__container___light"
  [ngClass]="{
    progress__indicator__dot___plansPage: page() === Page.plans,
  }"
>
  @for (item of flow(); track item; let i = $index) {
    <span
      class="progress__indicator__dot"
      [class.active]="i + 1 === step()"
      [class.complete]="i + 1 < step()"
    >
    </span>
  }
</div>
